import React from "react";
import { BiXCircle } from "react-icons/bi";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function MMInfoModal({ open, onClose }) {
  return (
    <Modal
      className={"mm-info-modal-content"}
      isOpen={open}
      toggle={() => onClose()}
    >
      <ModalBody>
        <div className="mb-3 mm-open-close-btn" style={{ display: "flex", justifyContent: "flex-end" }}>
          <BiXCircle className="cursor-pointer" onClick={onClose} size={25} />
        </div>
        <p>
          Please answer as many questions as you can to immediately see your Maturity Model Score.
        </p>
        <p>
          The overall rating measures the readiness of your organization for a
          positive and inclusive workplace culture.{" "}
        </p>
        <p>
          The 4 sub-scores identify the key gaps and opportunities to focus on.
        </p>
      </ModalBody>
    </Modal>
  );
}
